import { useState, useEffect } from "react";
import ApiKeysSection from "@/components/accounts/ApiKeysSection";
import EmailPreferencesSection from "@/components/accounts/EmailPreferencesSection";
import WeeklyReportsSection from "@/components/accounts/WeeklyReportsSection";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import DeleteWorkspaceModalForm from "@/components/accounts/DeleteWorkspaceModalForm";
import useCurrentAccount from "@/components/context/useCurrentAccount";
import { syncVisitorId } from "@/utils/visitorIdSync";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { PageHeader } from "@/components/ui/page-header";

export default function DashboardSettingsPage() {
  const [deleteWorkspaceModalOpen, setDeleteWorkspaceModalOpen] = useState(false);

  const { team } = useCurrentAccount({ requireLoggedIn: true });
  const isAdmin = team?.role === "admin";

  useEffect(() => {
    syncVisitorId();
  }, []);

  return (
    <DashboardLayout
      activePath="/dashboard/settings"
      title="Settings"
      breadcrumbs={[{ label: "Settings" }]}
    >
      <div className="mx-auto max-w-6xl px-4 py-8">
        <PageHeader
          title="Workspace Settings"
          description="Manage your workspace settings and preferences"
        />

        <div className="space-y-6">
          <ApiKeysSection />

          <EmailPreferencesSection />

          <WeeklyReportsSection />

          {isAdmin && (
            <Card className="border-destructive/50">
              <CardHeader>
                <CardTitle className="text-destructive">Danger Zone</CardTitle>
                <CardDescription>Irreversible and destructive actions</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <p className="text-sm text-muted-foreground mb-4">
                      Once you delete this workspace, there is no going back. All monitors,
                      contacts, and data will be permanently removed. Please be certain.
                    </p>
                    <Button variant="destructive" onClick={() => setDeleteWorkspaceModalOpen(true)}>
                      Delete Workspace
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        <DeleteWorkspaceModalForm
          open={deleteWorkspaceModalOpen}
          setOpen={setDeleteWorkspaceModalOpen}
        />
      </div>
    </DashboardLayout>
  );
}
